module.exports = __webpack_public_path__ + "img/empty-shared.ba9c1ba4.svg";